import styled, { css } from 'styled-components'

import { mobileMediaQuery } from '@subaio/webapp'

export const Container = styled.div`
	width: 100%;
	min-width: 500px;
	max-width: 100%;
	min-height: 550px;
	max-height: 100%;

	${mobileMediaQuery(css`
		min-width: unset;
		width: 100vw;
	`)}
`
